<template>
  <div class="tab-chats">
    <v-list two-line class="pa-0">
      <template v-for="(item, index) in filteredItems">
        <v-list-tile
          :key="item.title + index"
          avatar
          ripple
          :class="selected(item)"
          @click="itemClicked(item)"
          @contextmenu="showMenu(Number(item.chatId))"
        >
          <v-list-tile-avatar>
            <v-badge color="red" bottom overlap v-if="item.unread != 0">
              <span slot="badge">{{ item.unread > 99 ? '99+' : item.unread }}</span>
              <user-avatar 
                :avatar="item.avatar"
                :username="item.title" 
                :size="40"
              />
            </v-badge>
            <user-avatar v-else
              :avatar="item.avatar"
              :username="item.title" 
              :size="40"
            />
          </v-list-tile-avatar>        

          <v-list-tile-content>
            <v-list-tile-title 
              :class="{'tab-chats--unread':item.unread != 0}" 
              v-html="getTitle(item)"
            ></v-list-tile-title>
            <v-list-tile-sub-title 
              v-html="getMessageText(item)"
            ></v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-list-tile-action-text>{{ item.when }}</v-list-tile-action-text>
          </v-list-tile-action>
        </v-list-tile>

        <v-divider
          v-if="(index + 1) < filteredItems.length"
          :inset="true"
          :key="index"
        />

      </template>
    </v-list>

    <v-menu
      v-model="menuVisible"
      :position-x="x"
      :position-y="y"
      bottom
      offset-y
    >
      <v-list>
        <v-list-tile
          v-for="(item, index) in menuItems"
          :key="'menu' + index"
          @click="item.action"
        >
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<style lang="scss">
  .tab-chats {

    .v_list {
      overflow-x: hidden;
      overflow-y: overlay;
    }
  
    .v-badge__badge { 
      height:18px !important; 
      width:18px !important; 
      margin-bottom: 4px; 
    }
    .v-badge__badge span { 
      font-size:65%; 
    }
    .v-list--two-line .v-list__tile {
      height: auto !important;
      padding: 6px 16px;
    }
    .tab-chats--unread {
      font-weight: 500;
    }
    .v-list__tile__sub-title {
      min-height: 21px;
    }
  }
</style>


<script>
  import UserAvatar from '@common/UserAvatar.vue'
  import { EventBus } from '@/event-bus'
  import timeUtils from '@/utils/timeUtils'

  export default {
    name: 'tab-chats',
    components: { 
      UserAvatar,
    },
    data () {
      return {
        items: [],
        contextMenuData:[],
        contextMenuChatId: -1,
        menuVisible: false,
        menuItems: [
          { title: this.$t('chat_settings_header'), action: this.chatDetails },
          { title: this.$t('chat_delete_entry'), action: this.deleteChat },
          { title: this.$t('chat_menu_clear_history'), action: this.clearHistory },
        ],
        x: 0,
        y: 0,
      }
    },
    props: {
      filter: {
        type: String, 
        default: ''
      },
    },
    computed: {
      filteredItems() {
        let result
        if (this.filter !== '') {
          const filter = new RegExp(this.filter, 'i')
          result = this.items.filter(it => it.title.match(filter))
        } else {
          result = this.items
        }
        return result
      }
    },
    mounted() { 
      this.fetchChats()
      EventBus.$on('chat-message-updated', this.chatMessageUpdated)
      EventBus.$on('chat-deleted', this.fetchChats)
      EventBus.$on('chat-unread-changed', this.chatUnreadChanged)
    },
    beforeDestroy() {
      EventBus.$off('chat-message-updated')
      EventBus.$off('chat-deleted')
      EventBus.$off('chat-unread-changed')
    },
    methods: {
      fetchChats() {
        this.$store.dispatch('fetchChats').then(resp => {
          let chats = this.formatItems(resp)
          this.items = chats.filter(it => !(!it.group && it.lastMessage === ''))
          //this.itemClicked(this.items[0])
        })
      },
      chatUnreadChanged(ev) {
        console.log('-- (chatUnreadChanged): ', ev)
        this.fetchChats()
      },
      getContactName(contactId) {
        const con = this.$store.state.contacts.find(c => c.contactId === contactId)
        return (con !== undefined) ? con.name : contactId
      },
      formatItems(items) {
        // reformat messages for ui
        items.map(item => {
          switch (item.lastMessageType) {
            case this.types.TextMessage:
              // leave content as it is
              break
            case this.types.ImageMessage:
              item.lastMessage = item.sent ? this.$t('chat_picture_sent') : this.$t('chat_picture_received')
              break
            case this.types.VideoMessage:
              item.lastMessage = item.sent ? this.$t('chat_video_sent') : this.$t('chat_video_received')
              break
            case this.types.DocumentMessage:
              item.lastMessage = item.sent ? this.$t('chat_document_sent') : this.$t('chat_document_received')
              break
            case this.types.AudioMessage:
              item.lastMessage = item.sent ? this.$t('chat_voice_sent') : this.$t('chat_voice_received')
              break
            case this.types.ContactMessage:
              item.lastMessage = item.sent ? this.$t('chat_contact_sent') : this.$t('chat_contact_received')
              break
            case this.types.RemoveMessage: 
              item.lastMessage = item.sent 
                ? this.$t("message_you_deleted_notification") 
                : this.$t("message_deleted_notification", [this.getContactName(item.lastMessageUser)])
              break
            case this.types.LocationMessage:
              item.lastMessage = item.sent ? this.$t('chat_location_sent') : this.$t('chat_location_received')
              break
            case this.types.TimerMessage: {
                const username = this.getContactName(item.lastMessageUser)
                if (item.ttl > 0) {
                  const ttl = this.getTimerString(item.ttl)
                  item.lastMessage = item.sent 
                    ? this.$t('chat_timer_info_by_yourself', [ttl]) 
                    : this.$t('chat_timer_info', [username, ttl])                
                } else {
                  item.lastMessage = item.sent 
                    ? this.$t('chat_timer_info_cancel_by_yourself') 
                    : this.$t('chat_timer_info_cancel', [username])
                }
              }
              break
            case this.types.UserLeftMessage: {
                const name = this.getContactName(item.lastMessageUser)
                item.lastMessage = this.$t('chat_menu_leave_chat_sys_msg', [name])
              }
              break
            case this.types.UserAddedMessage: {
                let users = ''
                item.lastMessage.split('\n').forEach(userId => {
                  if (users != '') users += ', '
                  users += this.getContactName(userId)
                })
                if (item.sent) {
                  item.lastMessage = this.$t('chat_user_added_yourself',[users])
                } else {
                  const name = this.getContactName(item.lastMessageUser)
                  item.lastMessage = this.$t('chat_menu_add_users_sys_msg', [name, users]) 
                }
              }
              break
            case this.types.ChatDetailsMessage:
              if (item.extra) {
                const sender = this.getContactName(item.lastMessageUser)
                if (item.extra.notificationType == 0) {
                  item.lastMessage = item.sent 
                    ? this.$t('chat_title_changed_yourself', [item.extra.chatTitle])
                    : this.$t('chat_title_changed', [sender, item.extra.chatTitle])
                } else {
                  item.lastMessage = item.sent
                    ? this.$t('chat_image_changed_yourself')
                    : this.$t('chat_image_changed', [sender])
                }
              }
              break
            default:
              console.log('-- unsupported type', item.lastMessageType)
              item.lastMessage = ''
              break
          }

          item.when = this.getHumanTime(item.when)
          if (item.type == 2) {
            item.title = this.$t('app_name') 
            item.avatar = require('@assets/images/app-icon.png')
          }
        })
        return items
      },
      itemClicked(item) {
        this.$store.dispatch('openChatById', item.chatId)
      },
      selected(item) {
        return (item.chatId === this.$store.state.currentChat.chatId) ? 'selection' : '';
      },
      showMenu (chatId) {
        if (this.contextMenuChatId != -1)
          this.closeContextMenu()
        this.contextMenuChatId = chatId

        event.preventDefault()
        this.x = event.pageX
        this.y = event.pageY
        this.$nextTick(() => this.menuVisible = true)
      },
      chatDetails () {
        let item = this.$store.state.chats.find(it => it.chatId === this.contextMenuChatId)
        if (item && !item.readonly)
          EventBus.$emit('open-chat-details', this.contextMenuChatId)
      },
      deleteChat() {
        this.$store.dispatch('deleteChat', this.contextMenuChatId).then(() => {
          this.fetchChats()
        })
      },
      clearHistory() {
        this.$store.dispatch('clearHistory', this.contextMenuChatId)
      },
      closeContextMenu() {
        this.menuVisible = false
        this.contextMenuChatId = -1
      },
      getTitle(item) {
        return this.safeTextWithEmoji(item.title)
      },
      getMessageText(item) {
        return this.safeTextWithEmoji(item.lastMessage)
      },
      updateChat(chatId, messageId) {
        //TODO: let item = this.items.find(it => it.chatId === chatId)
        this.fetchChats()
      },
      chatMessageUpdated(args) {
        this.updateChat(args.chatId, args.messageId)
      },
    }
  }
</script>